import { Box, Skeleton, colors } from '@factorialco/deprecated-design-system'
import { ResponsiveLine } from '@nivo/line'

import skeletonData from './costsSkeletonData.json'

const EvolutionGraphLoadingSkeleton = () => (
  <Box gap="s64" width="full">
    <Box
      flexDirection="row"
      gap="s24"
      justifyContent="flexStart"
      maxWidth="s600"
      height="s96"
      paddingTop="s4"
      flexNoShrink
    >
      <Box flexGrow gap="s12">
        <Skeleton width="s48" />
      </Box>
    </Box>
    <Box height="s140" width="full">
      <ResponsiveLine
        data={skeletonData}
        margin={{ left: 64, top: 10, bottom: 64, right: 5 }}
        xScale={{ type: 'linear' }}
        yScale={{
          type: 'linear',
          min: 0,
          max: 30,
          stacked: false,
          reverse: false,
        }}
        axisLeft={{
          tickValues: [],
        }}
        enableGridY={false}
        gridYValues={4}
        colors={colors.grey300}
        yFormat=" >-.2f"
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickValues: [],
        }}
        pointSize={7}
        pointBorderWidth={2}
        pointLabelYOffset={-12}
        useMesh
        enableGridX={false}
        enableSlices="x"
        sliceTooltip={undefined}
        enablePoints={false}
        isInteractive={false}
        pointBorderColor={colors.grey300}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: colors.grey300,
              },
            },
          },
        }}
      />
    </Box>
  </Box>
)

export default EvolutionGraphLoadingSkeleton
